<template>
	<div class="login-main">
		<div class="title">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 40px;">
				{{lang == ('zh' || 'young') ? '用户登录' : 'Login'}}
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<Row>
			<Col span="9">
				<div class="input-line">
					{{lang == ('zh' || 'young') ? '手机号码' : 'Phone Number'}}：
				</div>
				<div class="input-line">
					{{lang == ('zh' || 'young') ? '密码' : 'Password'}}：
				</div>
			</Col>
			<Col span="14">
				<div class="input-right">
					<Input style="width: 240px;" v-model="telephone" maxlength="11"></Input>
					<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
				</div>
				<div class="input-right">
					<Input style="width: 240px;" v-model="password" type="password"></Input>
					<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
				</div>
			</Col>
		</Row>
		<div class="login-button" @click="login">
			{{lang == ('zh' || 'young') ? '登录' : 'Login'}}
		</div>
		<div style="margin-top: 20px; font-size: 12px; text-align: center;">
			{{lang == ('zh' || 'young') ? '没有账号？' : 'No account?'}}<span style="margin-left: 5px; color: #264EA7; cursor: pointer;" @click="toRegister">{{lang == ('zh' || 'young') ? '前往注册' : 'Register now'}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				telephone: '',
				password: ''
			}
		},
		mounted() {
			document.cookie = ""
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		methods: {
			encryptByDES(str){
				const key = 'WfJTKO9S4eLkrPz2JKrAnzdb'
				const iv = 'D076D35C'
				var cryptoKey = this.$CryptoJS.enc.Utf8.parse(key)
				var cryptoIv = this.$CryptoJS.enc.Utf8.parse(iv.substr(0, 8))
				var encodeStr = this.$CryptoJS.TripleDES.encrypt(str, cryptoKey, {
				    iv: cryptoIv,
				    mode: this.$CryptoJS.mode.CBC,
				    padding: this.$CryptoJS.pad.Pkcs7
				})
				return encodeStr.toString()
			},
			login() {
				let that = this
				if(!this.telephone) {
					var message = this.lang == ('zh' || 'young') ? '请输入手机号码' : 'Please type your phone number'
					that.$Message.error(message)
					return
				}
				if(!this.password) {
					var message = this.lang == ('zh' || 'young') ? '请输入密码' : 'Please type your password'
					that.$Message.error(message)
					return
				}
				let url = '/api/user/userLogin'
				if(this.lang == 'en') {
					url = '/api/en/user/userLogin'
				}
				var password = this.encryptByDES(that.password)
				that.$http.post({
					url: url,
					data: {
						"mobile": that.telephone,
						"pwd": password,
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.$http.setStorage('token', res.data.authToken)
						that.$http.setStorage('userId', res.data.id)
						if(that.$route.query.redirect) {
							that.$router.push(that.$route.query.redirect)
						} else {
							that.$router.push('grxx')
						}

					} else {
						that.$Message.error(res.msg)
					}
				})
			},
			toRegister() {
				let that = this
				if(that.$route.query.redirect) {
					this.$router.push({
						path: '/register',
						query: {
							redirect: that.$route.query.redirect
						}
					})
				} else {
					that.$router.push('register')
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.login-main {
		width: 50%;
		margin: 80px 25%;
		.title {
			display: flex;
			height: 80px;
			line-height: 80px;
			font-size: 15px;
			color: #264EA7;
			text-align: center;
			justify-content: center;
			i {
				font-size: 17px;
				color: #F8C822;
			}
		}
		.input-line {
			height: 30px;
			line-height: 30px;
			text-align: right;
			color: #686868;
			font-size: 15px;
			margin-top: 20px;
		}
		.input-right {
			height: 30px;
			line-height: 30px;
			font-size: 15px;
			margin-top: 20px;
			display: flex;
		}
		.login-button {
			width: 110px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			background-color: #264EA7;
			color: #FFFFFF;
			margin: 40px auto 0;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue